import React from 'react';
import Plans from '../component/plan/Plans';
import ComponenetHeader from '../component/common/ComponenetHeader';
import planIcon1 from '../assets/plan_icon1.webp';
import planIcon2 from '../assets/plan_icon2.webp';
import planIcon3 from '../assets/plan_icon3.webp';
import { Helmet } from 'react-helmet';

const PlanPage = () => {
  return (
    <>

     {/* <ComponenetHeader
        name={'Plans'}
      />  */}

      <Helmet>
        <link rel="canonical" href="/plans" />
        <title>Smart Trailer Repair Service Plans – Affordable. Fast. Easy</title>
        <meta name="keywords" content="trailer repair service, trailer repairs,truck service near me,trailer repair near me,Reefer Repair,truck and trailer repair shop near me, heavy duty truck repair, trailer repair shops"/>
        <meta name="description" content="Don’t let trailer issues ruin your route. Our smart trailer repair service plans offer unbeatable value, 24/7 support, and fast response. Start your plan today!"/>
        <meta property="og:title" content="Smart Trailer Repair Service Plans – Affordable. Fast. Easy" />
        <meta property="og:description" content="Don’t let trailer issues ruin your route. Our smart trailer repair service plans offer unbeatable value, 24/7 support, and fast response. Start your plan today!"/>
      </Helmet>

      <section className='new_plan-section'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-10'>
              <div className='plan_new_content'>
                <h1>How do Truck Repair Shop charges work?</h1>
                <p>With our flexible pay-as-you-go model, you pay only for the services you
                  offer and the time <br/>you use the platform—no contracts or hidden conditions.</p>
              </div>
              <div className='plan_new_highlight shadow'>
                <p>Just like utility bills such as water or electricity, you’re charged only for
                  what you use—no additional fees or termination costs when you stop using the
                  services. Learn how partnering with us can help you manage expenses more
                  efficiently and grow your business. Contact us for a customized estimate.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='new_plan-section_two'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='plan_new_content_two'>
                <h2>What’s the payment method?</h2>
              </div>
            </div>

            <div className='col-lg-4 col-md-12 mb-lg-0 mb-3'>
              <div className='new_plan_card h-100'>
                {/* <img src={planIcon1} className='img-fluid' alt='Pay-as-You-Go' /> */}
                <h3>On-Demand Billing</h3>
                <p>
                  Our pay-as-you-go model allows you to scale trailer repairs
                  and other services based on real demand, helping you avoid
                  overcommitments and reduce capacity risks. With flexible
                  pricing, you can easily adjust to changing needs and find
                  the right truck repair services near you, ensuring your
                  business stays agile and competitive in a fast-moving
                  market. Stay responsive without stretching your budget.
                </p>
              </div>
            </div>

            <div className='col-lg-4 col-md-12 mb-lg-0 mb-3'>
              <div className='new_plan_card h-100'>
                {/* <img src={planIcon2} className='img-fluid' alt='Save-with-Commitment' /> */}
                <h3>Commit and Save</h3>
                <p>
                Our platform offers valuable savings when you commit to providing services.
                Whether you focus on reefer repair or other roadside solutions, committing
                to a set level of service usage over one or three years allows you to benefit
                from lower costs compared to pay-as-you-go pricing. This approach gives you
                predictable expenses while maximizing your profit potential as a vendor.
                Start partnering with us today.
                </p>
              </div>
            </div>

            <div className='col-lg-4 col-md-12 mb-lg-0 mb-3'>
              <div className='new_plan_card h-100'>
                {/* <img src={planIcon3} className='img-fluid' alt='Pay-less-by-using-more' /> */}
                <h3>More Usage, More Savings</h3>
                <p>
                  At your truck and trailer repair shop, enjoy volume-based discounts
                  that reduce your cost per service as your bookings increase. Our
                  tiered pricing ensures that the more services you provide, the more
                  you save. With flexible plans that scale alongside your business,
                  you can grow efficiently while keeping expenses low. Whether you're
                  expanding your reach or collaborating with other trailer repair shops,
                  you’ll save more with every job.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Plans />

    </>
  );
};

export default PlanPage;
